module.exports = __webpack_public_path__ + "static/media/cheer.2c337eaf.jpg";